import React from 'react';
import WidgetToolbar, {
    WidgetToolbarProps,
} from 'widgets/WidgetToolbar/WidgetToolbar';
import './TileToolbar.scss';
import classNames from 'classnames';
import { SymbolFromConfigOrPortfolioLinkedTitle } from 'portfolio/components/SymbolFromConfigOrPortfolioLinkedTitle';
import { useTileContext } from 'widgets/tiles/components/tile/TileContext';

type TileToolbarProps = WidgetToolbarProps & {
    title: string | JSX.Element;
    subtitle?: string;
    wideTitle?: boolean;
};

export function TileToolbar(props: TileToolbarProps) {
    const { title, wideTitle, subtitle } = props;
    const { disableSymbolConfig } = useTileContext();

    const cssClasses = classNames(
        'TileToolbar panel-header capsule-header',
        wideTitle && 'wide-title',
        !disableSymbolConfig && 'show-symbol-title'
    );

    return (
        <div className={cssClasses}>
            {!disableSymbolConfig && (
                <div className="header">
                    <SymbolFromConfigOrPortfolioLinkedTitle />
                </div>
            )}
            <div
                className="title"
                title={typeof title === 'string' ? title : ''}
            >
                {title}
                {subtitle && <span className="subtitle">&nbsp;{subtitle}</span>}
            </div>
            <WidgetToolbar {...props} />
        </div>
    );
}
